import type { ItemUI } from '@libs/common-node';

export const itemHasAutoshipDiscountDisplayString = (cartItem: ItemUI): boolean =>
    typeof cartItem.autoshipDiscount === 'string' && cartItem.autoshipDiscount.trim() !== '';

export const applyPercentageToEligibleCartItemsState = (
    prevState: Record<string, string>,
    cartItems: ItemUI[],
    percentage: string
): Record<string, string> => {
    const next = { ...prevState };
    for (const cartItem of cartItems) {
        if (itemHasAutoshipDiscountDisplayString(cartItem)) {
            next[cartItem.id] = percentage;
        } else {
            delete next[cartItem.id];
        }
    }
    return next;
};

export const dynamicAutoshipPercentagesFromItems = (items: ItemUI[]): Record<string, string> =>
    Object.fromEntries(
        items
            .filter(itemHasAutoshipDiscountDisplayString)
            .map(cartItem => [cartItem.id, cartItem.autoshipDiscount as string])
    );

/** Clears stale keys when items lose autoship display; merges dynamic percentages from API/eligibility. */
export const mergeCrawlAutoshipPercentagesState = (
    prevState: Record<string, string>,
    items: ItemUI[]
): Record<string, string> => {
    const next = { ...prevState };
    for (const cartItem of items) {
        if (itemHasAutoshipDiscountDisplayString(cartItem)) {
            continue;
        }
        delete next[cartItem.id];
    }
    return { ...next, ...dynamicAutoshipPercentagesFromItems(items) };
};
